<template>
    <div class="photo-detail">
        <a-breadcrumb class="breadcrumb">
            <a-breadcrumb-item>您的位置</a-breadcrumb-item>
            <a-breadcrumb-item><a href="/ActivityPhotos/list">活動照片</a></a-breadcrumb-item>
            <a-breadcrumb-item><span v-text="title || '詳情'"></span></a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
            <div class="detail-wrapper" v-if="detail">
                <h1 v-text="detail.title"></h1>
                <div class="row">
                    <div class="create-time" v-text="`活動時間：${detail.actdate}`"></div>
                    <div class="font-setting">
                        字號：
                        <a class="font-item" @click="changeFontSize('24px')" href="javascript:;">大</a>
                        <a class="font-item" @click="changeFontSize('16px')" href="javascript:;">中</a>
                        <a class="font-item" @click="changeFontSize('12px')" href="javascript:;">小</a>
                    </div>
                </div>
                <viewer :options="{toolbar: false, navbar: false}" class="item" v-for="(item, index) in detail.mediasList" :key="index">
                    <img :src="item.p" alt="">
                    <p class="title" v-text="item.t" :style="{'font-size': fontSize}"></p>
                </viewer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
      return {
          title: '',
          detail: null,
          fontSize: '16px',
      }
    },
    mounted: function(){
        this.detail = JSON.parse(sessionStorage.getItem('detail'))
        this.title = (this.detail && this.detail.title) || ''
    },
    methods: {
      changeFontSize: function(size){
          this.fontSize = size
      }
    },
    watch: {
        '$route.params.id': function(id) {
            this.detail = JSON.parse(sessionStorage.getItem('detail'))
            this.title = (this.detail && this.detail.title) || ''
        }
    }
}
</script>

<style scoped>
    .photo-detail {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
    }

    .photo-detail {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-right: 20px;
    }

    .photo-detail > .breadcrumb {
        height: 36px;
        line-height: 36px;
        padding: 0 12px;
        background-color: #fff;
    }

    .photo-detail > .detail {
        margin-top: 12px;
        padding: 12px 20px;
        background-color: #fff;
        flex: 1;
        position: relative;
    }

    .photo-detail > .detail .row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        font-size: 16px;
        font-weight: 400;
        color: #999;
        margin-top: 20px;
    }

    .photo-detail > .detail .font-setting {
        margin-left: 20px;
        font-size: 16px;
        font-weight: 400;
        color: #999;
    }

    .photo-detail > .detail .font-setting .font-item {
        margin-left: 8px;
    }

    .photo-detail > .detail h1 {
        font-size: 32px;
        line-height: 41px;
        font-weight: bold;
        color: #1f1f1f;
        text-align: center;
    }

    .photo-detail > .detail .item {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        margin-bottom: 30px;
        margin-top: 20px;
    }

    .photo-detail > .detail .item > img {
        width: 96%;
        object-fit: contain;
    }

    .photo-detail > .detail .item > .title {
        font-size: 16px;
        font-weight: 400;
        color: #232323;
        line-height: 21px;
        margin-top: 12px;
    }

    @media only screen and (max-width: 1050px) {
        .photo-detail {
            width: 100%;
        }
    }
</style>
